/**
 * @description 엑셀 셀 값을 문자열로 정규화합니다. (공백 제거, 수식 처리 등)
 *
 * @param value 엑셀 셀 값
 * @returns {string} 정규화된 문자열 값
 */
export function normalizeExcelValue(value) {
    if (value === undefined || value === null) {
        return "";
    }
    if (value instanceof Date) {
        return value.toISOString();
    }
    if (typeof value === "object") {
        const formula = value;
        if ("formula" in formula) {
            const formulaResult = formula.result;
            return `${formula.formula}=${normalizeExcelValue(formulaResult)}`.trim();
        }
        return JSON.stringify(value);
    }
    return `${value}`.trim();
}
/**
 * @description 문자열을 정규화합니다. (공백 제거, 줄바꿈 및 탭 문자 제거 등)
 */
export function normalizeText(text) {
    return text
        .trim()
        .replace(/[\r\n\t]+/g, " ")
        .replace(/\s{2,}/g, " ");
}
